import "../style.css";
import React from "react";
import PanelContent from "../components/PanelContent";

export default function Avocats() {
  return (
    <PanelContent
      id="manifestants_panel"
      route="/manifestants"
      frTitle = "Deux avocats"
      enTitle = "Two Lawyers"
      frSubtitle = "Seuls contre tous"
      enSubtitle = "Alone Against All"
      frText = "Le ministre de l'Intérieur avait vivement soutenu la peine de mort en déclarant : 'J'aurais voté en faveur de la peine de mort.' Devant le palais de Justice de Troyes, la foule criait furieusement : 'À mort Patrick Henry !' L'opinion publique excluait toute réhabilitation. Patrick Henry lui-même avait affirmé que l'agresseur de l'enfant méritait la peine de mort."
      enText = "The Minister of the Interior had strongly supported the death penalty, declaring: 'I would have voted in favor of the death penalty.' In front of the Troyes courthouse, the crowd furiously shouted: 'Death to Patrick Henry!' Public opinion ruled out any possibility of rehabilitation. Patrick Henry himself stated that the child's assailant deserved the death penalty."
      frLeftButton=""
      enLeftButton = ""
      frRightButton="ÉTAPE SUIVANTE"
      enRightButton = "NEXT STEP"
      prev="/avocats"
      next="/verdict"
    />
  );
}
